module.exports = __webpack_public_path__ + "img/129.1bc85af0.jpg";